module.exports = __webpack_public_path__ + "img/odezhda.1fa19f4a.svg";